import { TwilioPhoneNumber } from '@/types/generated/graphql';
import { ClaimNumbersSchema } from '../schema/claim-numbers.schema';

export function buildDefaultValues(prefill: TwilioPhoneNumber | null): ClaimNumbersSchema {
  if (!prefill) {
    return { isoCountry: 'CA', capabilities: [], matchTo: 'any', numbers: [] };
  }

  return {
    isoCountry: prefill?.isoCountry + '',
    capabilities: Object.keys(prefill?.capabilities ?? {}).filter(
      //eslint-disable-next-line
      (key) => (prefill?.capabilities as any)?.[key]
    ),
    matchTo: 'any',
    numbers: [{ phoneNumber: prefill?.phoneNumber + '', friendlyName: prefill?.friendlyName + '' }],
  };
}
